type BuildShopUrlProps = {
  readonly articleId?: null | string
  readonly basketToken?: null | string
  readonly redirectUrl?: null | string
  readonly productId?: null | string
  readonly price?: null | number
  readonly promoPosition?: null | string
}

export function buildShopQueryParams({
  articleId = null,
  basketToken = null,
  productId = null,
  redirectUrl = null,
  price = null,
  promoPosition = null,
}: BuildShopUrlProps): string {
  const currentShopUrl = new URLSearchParams()

  if (productId !== null) {
    currentShopUrl.append("productId", productId)
  }

  if (basketToken !== null) {
    currentShopUrl.append("basketToken", basketToken)
  }

  if (articleId !== null) {
    currentShopUrl.append("articleId", articleId)
  }

  if (redirectUrl !== null) {
    currentShopUrl.append("redirectUrl", redirectUrl)
  }

  if (promoPosition !== null) {
    currentShopUrl.append("promo_position", promoPosition)
  }

  if (price !== null) {
    currentShopUrl.append("price", price.toString())
  }

  return currentShopUrl.toString()
}
